import { contStep3 } from './StepContract3'
import { contStep4 } from './StepContract4'
import { callSP, callSPUp } from '../../../../setup/axios/AxiosCallSP'
import { success, error, warn } from '../../../utils/customToasd'
import { ColDef, ColGroupDef } from 'ag-grid-community'
import { getSStorage, groupBy, removeSStorage } from '../../../../global.d'
import { Button } from 'app/utils/Button'

let arrayHijos: any = [];
export const validateIngredientsFrequency = (
  dataRow3: contStep3[],
  dataRow4: contStep4[],
  values: any,
  dataRow2: any,
  ingAdyacentes: any[],
  todasLasFrecuenciasSinFiltrar?: contStep4[], // Parámetro opcional con todas las frecuencias sin filtrar
) => {
  let totalEstructuraPadre: any = []
  let totalEstructuraComodin: any = []
  let fatherStructure: any = []
  let diasBloqueados: any = []
  let totalEstructuraPadreComodin: any = []
  dataRow2.map((item: any) => {
    if (totalEstructuraPadre[item.structure] === undefined) {
      totalEstructuraComodin[item.structure] = []
      totalEstructuraPadre[item.structure] = 0
      fatherStructure.push(item.structure)
    }
    if (typeof item.data.blockedDays !== 'string') {
      item.data.blockedDays?.map((day: any) => {
        let dataDay = day.text;
        if (dataDay === undefined) {
          dataDay = day;
        }
        if (diasBloqueados[item.structure.toString()] === undefined && dataDay !== '') {
          diasBloqueados[item.structure.toString()] = 0
        }
        diasBloqueados[item.structure.toString()] += values.weeks ? values.weeks : 4
      })
    }
  })
  dataRow3?.map((item) => {
    if (item.idCycleWeek) {
      if (item.fatherStructure2) {
        if (totalEstructuraPadre[item.fatherStructure2] === undefined) {
          totalEstructuraComodin[item.fatherStructure2.toString()] = []
          totalEstructuraPadre[item.fatherStructure2] = 0
          fatherStructure.push(item.fatherStructure2)
        }
        totalEstructuraPadre[item.fatherStructure2.toString()] +=
          item.idCycleWeek?.length * item.idDiaReceta.length
      }
    }
  })
  dataRow4?.map((item: any) => {
    if (item.frequency) {
      if (item.fatherStructure3) {
        if (totalEstructuraPadre[item.fatherStructure3.toString()] === undefined) {
          totalEstructuraPadre[item.fatherStructure3.toString()] = 0
        }
        totalEstructuraPadre[item.fatherStructure3.toString()] += item.frequency
        if (values.templateType[0].value == 3) {
          if (item.comodin) {
            if (totalEstructuraComodin[item.fatherStructure3][item.comodin] === undefined) {
              totalEstructuraComodin[item.comodin] = []
            }
            if (item.comodin != 'Normal')
              totalEstructuraComodin[item.fatherStructure3][item.comodin] = {
                continue: true,
                fatherStructure: item.fatherStructure3.toString(),
              }
          } else {
            if (item.comodin != 'Normal')
              totalEstructuraComodin[item.fatherStructure3][item.comodin] = {
                continue: true,
                fatherStructure: item.fatherStructure3.toString(),
              }
          }
        }
      }
      if (values.templateType[0].value == 3 && item.comodin !== "Normal") {
        if (item.comodin) {
          if (totalEstructuraPadreComodin[item.comodin] === undefined) {
            totalEstructuraPadreComodin[item.comodin] = []
          }
          totalEstructuraPadreComodin[item.comodin][item.fatherStructure3.toString()] = true
        } else {
          totalEstructuraPadreComodin[item.comodin][item.fatherStructure3.toString()] = false
        }
      }
    }
  })
  if (values.templateType[0].value == 3) {
    values.frequencyCycle = 31
  }
  let structure = ''
  let continueStep = true
  fatherStructure.forEach((item: any) => {
    const diasBloq = isNaN(diasBloqueados[item]) ? 0 : diasBloqueados[item]
    if (totalEstructuraPadre[item] !== values.frequencyCycle - diasBloq) {
      structure = item
      continueStep = false
    }
  })
  let total = 0
  const estFather = values.fatherStructure3[0]
    ? totalEstructuraPadre[values.fatherStructure3[0].text]
    : values.fatherStructure2[0]
      ? totalEstructuraPadre[values.fatherStructure2[0].text]
      : 0
  if (estFather !== undefined) total = values.frequency + estFather

  let continueAdjacent: boolean = true
  let warnAdjacent: string = ''
  if (dataRow4.length) {
    dataRow4.forEach((e: any) => {
      let hasPF: boolean = false
      let nMin: number = 0
      if (e.fatherStructure3.toLowerCase().includes('plato fondo')) {
        hasPF = true
        nMin = 12
      }
      if (e.fatherStructure3.toLowerCase().includes('plato de fondo')) {
        hasPF = true
        nMin = 15
      }

      if (hasPF) {
        let ingAcomp: any[] = ingAdyacentes.filter((i: any) => i.id_fondo == e.idMainIngredients2).map((i: any) => i.id_acompanamiento)
        if (ingAcomp.length) {
          let nFondo: any = e.fatherStructure3.substring(nMin, e.fatherStructure3.length)
          // CRÍTICO: Buscar acompañamientos SOLO en las estructuras seleccionadas (dataRow4 filtrado)
          // Si el usuario seleccionó solo ciertas estructuras, los acompañamientos también deben estar en esas estructuras
          // Usar dataRow4 (filtrado) en lugar de todasLasFrecuenciasSinFiltrar
          let acomps: any[] = dataRow4.filter((i: any) => ingAcomp.includes(parseInt(i.idMainIngredients2)) && i.fatherStructure3.substring(15, i.fatherStructure3.length) == nFondo)
          let acumFrec: number = acomps.reduce((acc: number, obj: any) => acc + obj.frequency, 0)
          
          // Solo validar si hay acompañamientos en las estructuras seleccionadas
          // Si no hay acompañamientos en las estructuras seleccionadas, permitir continuar
          if (acomps.length > 0 && acumFrec < e.frequency) {
            continueAdjacent = false
            warnAdjacent = `Los acompañamientos adyacentes al ingrediente de fondo ${e.mainIngredients2} (${e.fatherStructure3}) no suman una frecuencia de ${e.frequency}`
            return
          }
        }
      }
    })
  }
  return {
    total,
    continueStep,
    structure,
    totalEstructuraPadre,
    diasBloqueados,
    totalEstructuraComodin,
    continueAdjacent,
    warnAdjacent,
  }
}

export const validateStep4 = (
  dataRow2: any,
  dataRow3: contStep3[],
  values: any,
) => {
  let continueStep = true
  let warnBlockDays = ''
  let itemsValidate: any[] = []
  dataRow3.forEach((rf: any) => {
    const structure: any = dataRow2.find((str: any) => str.structure == rf.fatherStructure2)
    if (!!structure) {
      if (structure.idBlockedDays === undefined || structure.idBlockedDays == "")

        structure.idBlockedDays = []
      continueStep = !rf.idDiaReceta.map((d: any) =>
        parseInt(d)).some((e: any) =>
          structure.idBlockedDays.map((d: any) =>
            parseInt(d)).includes(e))
      if (!continueStep) {
        itemsValidate.push(`${rf.recipe} esta asignado a un dia bloquedo para la estructura ${structure.structure}`)
      }
    }
  })

  continueStep = itemsValidate.length === 0
  warnBlockDays = itemsValidate.join(', ')

  return {
    continueStep,
    warnBlockDays,
  }
}

export const validateStep1 = (values: any) => {
  if (values.homologada && !isValid(values, 'templateHomologada', 'Debe sleccionar el contrato a homologar')) return false
  if (!isValid(values, 'templateType', 'Debe ingresar tipo de plantilla')) return false
  if (!values.frequencyCycle || values.frequencyCycle === '' || values.frequencyCycle == 0) {
    warn('Ciclo de frecuencia debe ser mayor a cero')
    return false
  }
  if (!isValid(values, 'frequencyType', 'Debe ingresar tipo de frecuencia')) return false

  if (!isValid(values, 'place', 'Debe ingresar sitio')) return false
  if (!isValid(values, 'service', 'Debe ingresar servicio')) return false
  if (!isValid(values, 'regime', 'Debe ingresar regimen')) return false
  if (!values.monthlyCost || values.monthlyCost === '' || values.monthlyCost == 0) {
    warn('Costo objetivo mensual debe ser mayor a cero')
    return false
  }

  if (!values.monthlyCost || values.monthlyCost === '' || values.monthlyCost == 0) {
    warn('Costo objetivo mensual debe ser mayor a cero')
    return false
  }

  if (
    values.monday &&
    (!values.quantityMonday || values.quantityMonday === '')
  ) {
    if (!values.homologada && values.quantityMonday === 0) {
      warn('Comensales para el día Lunes debe ser mayor a cero')
      return false
    }
  }
  if (
    values.tuesday &&
    (!values.quantityTuesday || values.quantityTuesday === '')
  ) {
    if (!values.homologada && values.quantityTuesday === 0) {
      warn('Comensales para el día Martes debe ser mayor a cero')
      return false
    }
  }
  if (
    values.wednesday &&
    (!values.quantityWednesday || values.quantityWednesday === '')
  ) {
    if (!values.homologada && values.quantityWednesday === 0) {
      warn('Comensales para el día Miercoles debe ser mayor a cero')
      return false
    }
  }
  if (
    values.thursday &&
    (!values.quantityThursday || values.quantityThursday === '')
  ) {
    if (!values.homologada && values.quantityThursday === 0) {
      warn('Comensales para el día Jueves debe ser mayor a cero')
      return false
    }
  }
  if (
    values.friday &&
    (!values.quantityFriday || values.quantityFriday === '')
  ) {
    if (!values.homologada && values.quantityFriday === 0) {
      warn('Comensales para el día Viernes debe ser mayor a cero')
      return false
    }
  }
  if (
    values.saturday &&
    (!values.quantitySaturday || values.quantitySaturday === '')
  ) {
    if (!values.homologada && values.quantitySaturday === 0) {
      warn('Comensales para el día Sabado debe ser mayor a cero')
      return false
    }
  }
  if (
    values.sunday &&
    (!values.quantitySunday || values.quantitySunday === '')
  ) {
    if (!values.homologada && values.quantitySunday === 0) {
      warn('Comensales para el día Domingo debe ser mayor a cero')
      return false
    }
  }

  return true
}

export const validateStep6 = (values: any) => {
  if (values.ruleCruceRule) {
    if (!isValid(values, 'reglaSitio', 'Debe selecionar Sitio')) return false
    if (!isValid(values, 'reglaRegimen', 'Debe selecionar Regimen')) return false
    if (!isValid(values, 'reglaServicios', 'Debe selecionar Servicio')) return false

    return true
  }

  return true
}

// TODO validar status de los servicios
export const saveContract = async (values: any, step2: any, step3: any, step4: any, step5: any, isHomologada: boolean) => {
  let idcontrato: any = null
  let isEdit: boolean = false
  try {
    let tipo_plantilla: any = null

    let estructuras: any[]
    let responseEstFija: any
    let responseRecetaFija: any
    let responseFrecContrato: any

    // step 1
    if (validateStep1(values)) {
      // amd_insertContratoServicio
      const date: string = new Date().toISOString().substring(0, 10)
      tipo_plantilla = values.templateType[0].value.toString()

      let ciclo_plantilla: any = values.frequencyCycle
      if (tipo_plantilla == '1') ciclo_plantilla = values.frequencyCycle / values.weeks
      if (tipo_plantilla == '3') ciclo_plantilla = '28'
      if (values.contractId === undefined) {
        values.contractId = await getSStorage("contractId");
      }
      // Obtener contratos múltiples de templateHomologada2 y convertirlos a cadena separada por punto y coma
      let contratosMultiplesStr = '0'
      if (values.templateHomologada2 && Array.isArray(values.templateHomologada2) && values.templateHomologada2.length > 0) {
        const contratosIds = values.templateHomologada2.map((c: any) => {
          if (typeof c === 'object' && c !== null) {
            return c.value || c.id || c
          }
          return c
        }).filter((id: any) => id && id !== '' && id !== 0)
        
        if (contratosIds.length > 0) {
          contratosMultiplesStr = contratosIds.join(';')
        }
      }
      
      const arrayBodyContrato: any[] = [
        { text: 'id', value: values.contractId ? values.contractId.toString() : '0' },//TODO: REVISAR contractId ENVIO HOMOLOGADO
        { text: 'id_sitio', value: values.place[0].value.toString() },
        { text: 'id_tipo_servicio', value: values.service[0].value.toString() },
        { text: 'id_regimen ', value: values.regime[0].value.toString() },
        { text: 'costo_objetivo_mensual', value: values.monthlyCost.toString() },
        {
          text: 'ciclo_minuta',
          value: tipo_plantilla != '3' ? values.frequencyCycle.toString() : '1',
        },
        { text: 'ciclo_plantilla', value: ciclo_plantilla.toString() },
        { text: 'ciclos', value: getCiclos(tipo_plantilla, values.weeks) },
        //{ text: 'fecha_creacion', value: date },
        { text: 'fecha_creacion', value: new Date(values.fechaCreacion).toISOString().substring(0, 10) },
        { text: 'id_tipo_plantilla', value: tipo_plantilla },
        { text: 'id_tipo_frecuencia', value: values.frequencyType[0].value.toString() },
        { text: 'id_contr_rel', value: isHomologada ? values.templateHomologada[0].value.toString() : '0' }, // probar validacion
        { text: 'id_contr_rel2', value: contratosMultiplesStr }, // Contratos múltiples separados por punto y coma
      ]

      const responseContract = await callSP('amd_insertContratoServicio', arrayBodyContrato)
      // if (!await evaluateResponse(responseContract, 'Error al crear contrato!', idcontrato)) return false //throw('Error al crear contrato!')
      idcontrato = values.contractId ? values.contractId.toString() : responseContract.data.result[0].idcontrato?.toString()
      isEdit = values.contractId && !isHomologada ? true : false
      // amd_insertDiaSemanaContrato
      const diasSemana: any[] = [
        [
          { text: 'id', value: values.mondayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.monday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantityMonday}` },
          { text: 'n_dia', value: '1' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.tuesdayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.tuesday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantityTuesday}` },
          { text: 'n_dia', value: '2' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.wednesdayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.wednesday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantityWednesday}` },
          { text: 'n_dia', value: '3' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.thursdayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.thursday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantityThursday}` },
          { text: 'n_dia', value: '4' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.fridayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.friday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantityFriday}` },
          { text: 'n_dia', value: '5' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.saturdayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.saturday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantitySaturday}` },
          { text: 'n_dia', value: '6' },
          { text: 'dia', value: '' },
        ],
        [
          { text: 'id', value: values.sundayId },
          { text: 'id_contrato', value: idcontrato },
          { text: 'estado', value: values.sunday ? '1' : '0' },
          { text: 'q_comensales', value: `${values.quantitySunday}` },
          { text: 'n_dia', value: '7' },
          { text: 'dia', value: '' },
        ],
      ]
      const arrayBodyDiaSemana: any = []
      diasSemana.forEach((e: any) => {
        arrayBodyDiaSemana.push(setParametersByArray(e))
      })
      const responseDiaSemana: any = await callSPUp(
        'amd_insertDiaSemanaContrato',
        arrayBodyDiaSemana
      )
      // if (!await evaluateResponse(responseDiaSemana, 'Error al registrar dias Y comensales del contrato!', idcontrato)) return false // throw('Error al registrar dias Y comensales del contrato!')
    } else return false

    // step 2
    if (step2.length) {
      // amd_insertEstructuraContrato
      const arrayBodyEstContr: any[] = []
      step2.forEach((e: any, i: any) => {
        arrayBodyEstContr.push(
          setParametersEstContr(
            i.toString(),
            idcontrato.toString(),
            values.service[0].value.toString(),
            e.idFatherStructure.toString(),
            '3',
            '1',
            e.idTolerance.toString(),
            e.idAllergens.toString(),
            e.idDietaryCategory.toString(),
            e.structure,
            e.idStructure.toString(),
            '0',
            e.idBlockedDays.length ? e.idBlockedDays.join(',') : '',
            e.idPlateType.toString(),
            e.order.toString(),
            e.idEstRel ? e.idEstRel.toString() : "0",
          )
        )
        // e.idAllowsStamp.toString(),
      })
      const responseEstContr: any = await callSPUp(
        'amd_insertEstructuraContrato',
        arrayBodyEstContr
      )
      // if (!await evaluateResponse(responseEstContr, 'Error al registrar estructuras del contrato!', idcontrato)) return false // throw('Error al registrar estructuras del contrato!')
      estructuras = responseEstContr.data.result
    } else {
      warn('Debe crear estructuras')
      return
    }

    // step 3
    // amd_insertEstructuraFija
    const arrayBodyEstFija: any[] = []
    if (step3.length) {
      step3.forEach((e: any, i: number) => {
        arrayBodyEstFija.push(setParametersEstFija(
          i.toString(),
          idcontrato,
          e.idRecipe.toString(),
          e.idFatherStructure4.toString(),
          e.idEstRel ? e.idEstRel.toString() : '0',
          e.id_estructura.toString()
        ))
      })
    } else {
      arrayBodyEstFija.push(setParametersEstFija('0', idcontrato, '0', '0', '0', '0'))
    }

    responseEstFija = await callSPUp('amd_insertEstructuraFija', arrayBodyEstFija)
    // if (!await evaluateResponse(responseEstFija, 'Error al registrar estructuras fijas del contrato!', idcontrato)) return false // throw('Error al registrar estructuras fijas del contrato!')

    // step 4
    // amd_insertRecetaFija
    const arrayBodyRecetaFija: any[] = []
    step4.forEach((e: any) => {
      arrayBodyRecetaFija.push(
        setParametersRecetaFija(
          getIdEstr(e.fatherStructure2, estructuras),
          e.idRecipe.toString(),
          e.idMainIngredients.toString(),
          e.idDiaReceta.join(','),
          e.idCycleWeek.join(','),
          tipo_plantilla != '3' ? '0' : e.idIntercalaryWeek.toString(),
          e.idDietaryCategory2.toString(),
        )
      )
    })
    // tipo_plantilla != '3' ? e.idCycleWeek.join(',') : '1,2,3,4',
    responseRecetaFija = await callSPUp('amd_insertRecetaFija', arrayBodyRecetaFija)
    // if (!await evaluateResponse(responseRecetaFija, 'Error al registrar recetas fijas del contrato!', idcontrato)) return false // throw('Error al registrar recetas fijas del contrato!')

    // step 5
    if (step5.length) {
      // amd_insertFrecuenciaContrato
      const arrayBodyFrecContrato: any[] = []
      step5.forEach((e: any) => {
        arrayBodyFrecContrato.push(
          setParametersFrecContrato(
            getIdEstr(e.fatherStructure3, estructuras),
            e.idMainIngredients2.toString(),
            e.frequency.toString(),
            getCycles4(tipo_plantilla, e.idCycles4),
            e.idComodin,
            e.idDietaryCategory3.toString(),
          )
        )
      })
      responseFrecContrato = await callSPUp('amd_insertFrecuenciaContrato', arrayBodyFrecContrato)
      // if (!await evaluateResponse(responseFrecContrato, 'Error al registrar frecuencia de ingredientes del contrato!', idcontrato)) return false //throw('Error al registrar frecuencia de ingredientes del contrato!')
    } else {
      warn('Debe ingregar frecuencia de ingredientes')
      return
    }

    // step 6
    const rules: any[] = [
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '1' },
        { text: 'estado', value: values.ruleColorDistribution ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '2' },
        { text: 'estado', value: values.ruleRecipeRepeat ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '3' },
        { text: 'estado', value: values.ruleDescriptiveCost ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '4' },
        { text: 'estado', value: values.ruleGarnitureCruce ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '5' },
        { text: 'estado', value: values.ruleNameRepeat ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '6' },
        { text: 'estado', value: values.ruleRemoriceEfect ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '7' },
        { text: 'estado', value: values.ruleComplexityRecipes ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '8' },
        { text: 'estado', value: values.ruleCookingMethod ? '1' : '0' },
        { text: 'sitio', value: '0', },
        { text: 'regimen', value: '0' },
        { text: 'servicio', value: '0' },
      ],
      [
        { text: 'id_contrato', value: idcontrato },
        { text: 'regla', value: '9' },
        { text: 'estado', value: values.ruleCruceRule ? '1' : '0' },
        { text: 'sitio', value: values.ruleCruceRule ? values.reglaSitio[0].value.toString() : '0' },
        { text: 'regimen', value: values.ruleCruceRule ? values.reglaRegimen[0].value.toString() : '0' },
        { text: 'servicio', value: values.ruleCruceRule ? values.reglaServicios[0].value.toString() : '0' },
      ],
    ]
    const arryBodyRules: any[] = []
    rules.forEach((e: any) => {
      arryBodyRules.push(setParametersByArray(e))
    })
    const responseRules: any = await callSPUp('amd_insertEstadoReglasContrato', arryBodyRules)
    // if (!await evaluateResponse(responseRules, 'Error al registrar reglas del contrato!', idcontrato)) return false // throw('Error al registrar reglas del contrato!')

    // amd_insertFrecuenciaByContrato
    const responseFrecuenciaByContrato = await callSP('amd_insertFrecuenciaByContrato', [
      { text: 'contrato', value: idcontrato },
    ])
    // if (!await evaluateResponse(responseFrecuenciaByContrato, 'Error al registrar contrato!', idcontrato)) return false // throw('Error al registrar contrato!')
    if (responseFrecuenciaByContrato.data.status == 200) {
      success(`Contrato ${!isEdit ? 'creado' : 'editado'} con exito!`)
      removeSStorage('contractId')
      return true
    } else {
      return false
    }
  } catch (e: any) {
    if (e) {
      console.log('Error', e)
      error(e)
    } else error('Error al crear el contrato!')
    if (idcontrato && !isEdit) await deleteContrato(idcontrato)

    if (e.response) {
      // Request made and server responded
    } else if (e.request) {
      // The request was made but no response was received
      console.log(e.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', e.message)
    }
    return false
  }
}

// TODO id_estilo_aliminatacion y relacion por ahora estan pasandose en duro
export const setParametersEstContr = (
  id: string,
  id_contrato: string,
  id_servicio: string,
  id_estructura: string,
  id_estilo_aliminatacion: string,
  id_sellos: string,
  id_intolerancia: string,
  id_alergeno: string,
  id_categoria_dietetica: string,
  estructura: string,
  id_estructura_hijo: string,
  relacion: string,
  diasBloqueados: string,
  tipo_plato: string,
  order: string,
  id_est_rel: string
) => {
  return {
    parameters: [
      { text: 'id', value: id },
      { text: 'id_contrato', value: id_contrato },
      { text: 'id_servicio', value: id_servicio },
      { text: 'id_estructura', value: id_estructura },
      { text: 'id_estilo_aliminatacion', value: id_estilo_aliminatacion },
      { text: 'id_sellos', value: id_sellos },
      { text: 'id_intolerancia', value: id_intolerancia },
      { text: 'id_alergeno', value: id_alergeno },
      { text: 'id_categoria_dietetica', value: id_categoria_dietetica },
      { text: 'estructura', value: estructura },
      { text: 'id_estructura_hijo', value: id_estructura_hijo },
      { text: 'relacion', value: relacion },
      { text: 'diasBloqueados', value: diasBloqueados },
      { text: 'tipo_plato', value: tipo_plato },
      { text: 'order', value: order },
      { text: 'id_est_rel', value: id_est_rel },
    ],
  }
}

export const setParametersByArray = (arr: any) => {
  return {
    parameters: arr,
  }
}

export const setParametersEstFija = (id: string, id_contrato: string, id_receta: string, id_grupo_estructura: string, id_est_rel: string, id_estructura: string) => {
  return {
    parameters: [
      { text: 'id', value: id },
      { text: 'id_contrato', value: id_contrato },
      { text: 'id_receta', value: id_receta },
      { text: 'id_grupo_estructura', value: id_grupo_estructura },
      { text: 'id_est_rel', value: id_est_rel },
      { text: 'indice', value: id },
      { text: 'id_estructura', value: id_estructura },
    ],
  }
}

export const setParametersRecetaFija = (
  id_estructura_contrato: string,
  id_receta: string,
  id_ingrediente_principal: string,
  dia_ciclo: string,
  ciclo: string,
  intercalado: string,
  id_categoria_dietetica: string,
) => {
  return {
    parameters: [
      { text: 'id_estructura_contrato', value: id_estructura_contrato },
      { text: 'id_receta', value: id_receta },
      { text: 'id_ingrediente_principal', value: id_ingrediente_principal },
      { text: 'dia_ciclo', value: dia_ciclo },
      { text: 'ciclo', value: ciclo },
      { text: 'intercalado', value: intercalado },
      { text: 'id_categoria_dietetica', value: id_categoria_dietetica },
    ],
  }
}

export const setParametersFrecContrato = (
  id_estructura_contrato: string,
  id_ingrediente_principal: string,
  cantidad_frecuencia: string,
  semana: string,
  comodin: string,
  id_categoria_dietetica: string,
) => {
  return {
    parameters: [
      { text: 'id_estructura_contrato', value: id_estructura_contrato },
      { text: 'id_ingrediente_principal', value: id_ingrediente_principal },
      { text: 'cantidad_frecuencia', value: cantidad_frecuencia },
      { text: 'semana', value: semana },
      { text: 'comodin', value: comodin },
      { text: 'id_categoria_dietetica', value: id_categoria_dietetica },
    ],
  }
}

const getIdEstr = (str: string, arr: any[]) => {
  const est = arr.find((e: any) => e.estructura == str)
  if (est.id == undefined) {
    error('No existe estructura ' + str)
  }
  return est.id.toString()
}

export const headerDetailFrequency = () => {
  return [
    {
      field: 'structure',
      headerName: 'Estructura',
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'total',
      headerName: 'Total Frecuencia',
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'admitted',
      headerName: 'Ingresados',
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
}

export const getColumRecetaGrid = (filter: any) => {
  const dataColum: (ColDef | ColGroupDef)[] = [
    {
      headerName: 'Seleccionar',
      maxWidth: 150,
      cellRenderer: (params: any) => {
        return (
          <i
            style={{ cursor: 'pointer' }}
            onClick={() => {
              return filter(params)
            }}
            className='bi bi-check-circle'
          ></i>
        )
      },
    },
    {
      field: 'rec_codigo',
      headerName: 'Id Receta',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'text',
      headerName: 'Receta',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'Nombretipoingprincipal',
      headerName: 'Ingrediente Principal',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreColor',
      headerName: 'Nombre Color',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreCosto',
      headerName: 'Costo',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreMetodoCoccion',
      headerName: 'Metodo Cocción',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'NombreCategorizacionCompleja',
      headerName: 'Complejidad',
      minWidth: 205,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
  return dataColum
}

const getCiclos = (templateType: string, weeks: any) => {
  if (templateType == '1') return weeks ? weeks.toString() : ''
  else if (templateType == '2') return '1'
  else return '4'
}

const getCycles4 = (templateType: string, weeks: any) => {
  if (templateType == '1') return weeks ? weeks.join(',') : ''
  else if (templateType == '2') return '1'
  else return '1,2,3,4'
}

export const mapCatDietetica: any = (arr: any[], field?: string) => {
  const allText = true
  if (field == 'codigobisnieto') {
    const bisnieto: any[] = arr.map((e: any, key: number) => {
      let label = e.nombrebisnieto
      if (allText) {
        label = `${e.car_nombre}/${e.nombrehijo}/${e.nombrenieto}/${e.nombrebisnieto}`
      }
      return {
        ...e,
        label: e.nombrebisnieto,
        tagLabel: label,
        title: label,
        value: e.codigobisnieto,
        disabled: false,
      }
    })
    if (bisnieto.length > 0) {
      arrayHijos = arr.filter((item: any) => item.nombrebisnieto == 0 && item.nombrenieto == 0 && item.codigohijo != 0)
    }
    return mapCatDietetica(bisnieto, 'codigonieto')
  }
  if (field == 'codigonieto') {
    const nietos: any[] = Object.values(groupBy(arr, 'codigonieto')).map((e: any, key: number) => {
      const bis: any[] = e.filter((n: any) => n.codigobisnieto != 0)
      if (bis.length) {
        let label = e[0].nombrenieto
        if (allText) {
          label = `${e[0].car_nombre}/${e[0].nombrehijo}/${e[0].nombrenieto}`
        }
        return {
          label: e[0].nombrenieto,
          tagLabel: label,
          title: label,
          value: e[0].codigonieto,
          disabled: true,
          children: bis,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
          codigohijo: e[0].codigohijo,
          nombrehijo: e[0].nombrehijo,
          codigonieto: e[0].codigonieto,
          nombrenieto: e[0].nombrenieto,
        }
      } else {
        let label = e[0].nombrenieto
        if (allText) {
          label = `${e[0].car_nombre}/${e[0].nombrehijo}/${e[0].nombrenieto}`
        }
        return {
          label: e[0].nombrenieto,
          tagLabel: label,
          title: label,
          value: e[0].codigonieto,
          disabled: false,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
          codigohijo: e[0].codigohijo,
          nombrehijo: e[0].nombrehijo,
          codigonieto: e[0].codigonieto,
          nombrenieto: e[0].nombrenieto,
        }
      }
    })
    return mapCatDietetica(nietos, 'codigohijo')
  }

  if (field == 'codigohijo') {
    const hijos: any[] = Object.values(groupBy(arr, 'codigohijo')).map((e: any) => {
      const nieto: any[] = e.filter((n: any) => n.codigonieto != 0)
      let label = e[0].nombrehijo
      if (allText) {
        label = `${e[0].car_nombre}/${e[0].nombrehijo}`
      }
      if (nieto.length) {
        return {
          label: e[0].nombrehijo,
          tagLabel: label,
          title: label,
          value: e[0].codigohijo,
          disabled: true,
          children: nieto,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
          codigohijo: e[0].codigohijo,
          nombrehijo: e[0].nombrehijo,
        }
      } else {
        let label = e[0].nombrehijo
        if (allText) {
          label = `${e[0].car_nombre}/${e[0].nombrehijo}`
        }
        return {
          label: e[0].nombrehijo,
          tagLabel: label,
          title: label,
          value: e[0].codigohijo,
          disabled: false,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
          codigohijo: e[0].codigohijo,
          nombrehijo: e[0].nombrehijo,
        }
      }
    })
    if (arrayHijos.length > 0) {
      Object.values(groupBy(arrayHijos, 'codigohijo')).forEach((e: any) => {
        const nieto: any[] = e.filter((n: any) => n.codigonieto != 0)
        let label = e[0].nombrehijo
        if (allText) {
          label = `${e[0].car_nombre}/${e[0].nombrehijo}`
        }
        if (nieto.length) {
          return {
            label: e[0].nombrehijo,
            tagLabel: label,
            value: e[0].codigohijo,
            disabled: true,
            children: nieto,

            car_codigo: e[0].car_codigo,
            car_nombre: e[0].car_nombre,
            codigohijo: e[0].codigohijo,
            nombrehijo: e[0].nombrehijo,
          }
        } else {
          let label = e[0].nombrehijo
          if (allText) {
            label = `${e[0].car_nombre}/${e[0].nombrehijo}`
          }
          hijos.push({
            label: e[0].nombrehijo,
            tagLabel: label,
            value: e[0].codigohijo,
            disabled: false,

            car_codigo: e[0].car_codigo,
            car_nombre: e[0].car_nombre,
            codigohijo: e[0].codigohijo,
            nombrehijo: e[0].nombrehijo,
          })
        }
      })
    }
    return mapCatDietetica(hijos, 'car_codigo')
  }

  if (field == 'car_codigo') {
    const cats: any[] = Object.values(groupBy(arr, 'car_codigo')).map((e: any) => {
      const hijo: any[] = e.filter((n: any) => n.codigohijo != 0)
      if (hijo.length) {
        return {
          label: e[0].car_nombre,
          value: e[0].car_codigo,
          tagLabel: e[0].car_nombre,
          title: e[0].car_nombre,
          disabled: true,
          children: hijo,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
        }
      } else {
        return {
          label: e[0].car_nombre,
          value: e[0].car_codigo,
          tagLabel: e[0].car_nombre,
          title: e[0].car_nombre,
          disabled: false,

          car_codigo: e[0].car_codigo,
          car_nombre: e[0].car_nombre,
        }
      }
    })
    return cats
  }
}

export const getPlateTypesLevels = async (plateType: any, arr: any[] = []) => {
  const typesLevel2: any[] = await arr
    .filter((i: any) => i.tip_previo == plateType)
    .map((i: any) => i.tip_codigo)
  const typesLevel3: any[] = await arr
    .filter((i: any) => typesLevel2.includes(i.tip_previo))
    .map((i: any) => i.tip_codigo)

  return typesLevel3.concat(typesLevel2)
}

export const isValid = (values: any, field: string, msg: string) => {
  if (
    !values[field] ||
    values[field].value == '' ||
    !values[field].length ||
    !values[field][0] ||
    values[field][0].value === ''
  ) {
    warn(msg)
    return false
  }

  return true
}

export const getTemplateTypeText = (id: string) => {
  if (id == '1') return 'Rotativa Normal'
  if (id == '2') return 'Minuta Fija'

  return 'No Rotativa'
}

export const getFrequencyTypeText = (id: string) => {
  if (id == '0') return 'Sodexo'

  return 'Contractual'
}

export const deleteContrato = async (id: string) => {
  const response = await callSP('amd_deleteContrato', [{ text: 'contrato', value: id }])
  if (response.data.status == 200) {
    success('Contrato eliminado con exito!')
    return true
  } else {
    error('Error al eliminar el contrato!')
    return false
  }
}

//paser el msj aca
export const evaluateResponse = async (response: any, msg: string, idcontrato: string) => {
  if (response.data.status == 200) {
    return true
  } else {
    error(msg)

    if (idcontrato) await deleteContrato(idcontrato)
    return false
  }
}

export const editStepGrid = (params: any, callbackEdit: any, formikProps?: any) => {
  return (
    <>
      <Button
        className='btn-table'
        type='button'
        onClick={() => {
          callbackEdit(params.data, formikProps, params)
        }}
      >
        <i className='bi bi-pencil-square icon-action'></i>
      </Button>
    </>
  )
}

export const mapDaysStr = (day: number) => {
  // day: 1 ... 7
  if (day == 1) return 'Lunes'
  if (day == 2) return 'Martes'
  if (day == 3) return 'Miércoles'
  if (day == 4) return 'Jueves'
  if (day == 5) return 'Viernes'
  if (day == 6) return 'Sabado'

  return 'Domingo'
}
